import React, { useState, useEffect } from 'react';
import {
    Button, Card, CardContent, Typography, makeStyles, TextField,
    MenuItem, Select, FormControl, InputLabel, Container, Box, CircularProgress
} from '@material-ui/core';
import { db } from '../firebaseConfig';
import { EnumColors } from '../enum/EnumColors';
import { ocultar, revelar } from '../Utils';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: '20px',
        padding: '10px',
        display: 'flex',
        justifyContent: 'center'
    },
    card: {
        padding: theme.spacing(3),
        textAlign: 'center',
        borderRadius: '20px',
        backgroundColor: '#fdfdfd',
        minHeight: '500px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
    },
    // --- ARTE: COPO AMERICANO ---
    copoAmericano: {
        width: '120px',
        height: '160px',
        border: '3px solid rgba(255, 255, 255, 0.9)',
        borderBottomWidth: '10px',
        borderRadius: '5px 5px 25px 25px',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0.1) 100%)',
        backdropFilter: 'blur(4px)',
        position: 'relative',
        boxShadow: '0 15px 25px rgba(0,0,0,0.15)',
        margin: '30px auto',
        overflow: 'hidden',
        zIndex: 1
    },
    papelAmassado: {
        backgroundColor: '#fff',
        borderRadius: '30% 70% 50% 50% / 50% 30% 70% 50%',
        border: '1px solid #ddd',
        position: 'absolute',
        bottom: '10px',
        boxShadow: '1px 1px 3px rgba(0,0,0,0.1)',
    },
    // --- ANIMAÇÕES ---
    shakeCopo: {
        animation: '$shakeCopoAnim 0.15s infinite alternate'
    },
    mixPapel: {
        animation: '$randomMove 0.6s infinite ease-in-out'
    },
    "@keyframes shakeCopoAnim": {
        "from": { transform: "translateX(-8px) rotate(-3deg)" },
        "to": { transform: "translateX(8px) rotate(3deg)" }
    },
    "@keyframes randomMove": {
        "0%": { transform: "translate(0, 0) rotate(0deg)" },
        "25%": { transform: "translate(25px, -60px) rotate(90deg)" },
        "50%": { transform: "translate(-15px, -120px) rotate(180deg)" },
        "75%": { transform: "translate(-25px, -50px) rotate(270deg)" },
        "100%": { transform: "translate(0, 0) rotate(360deg)" }
    },
    revelarPapel: {
        animation: '$openPaper 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        backgroundColor: '#fffbe6',
        padding: '30px 20px',
        border: '1px solid #e6db99',
        borderRadius: '5px',
        boxShadow: '5px 5px 0px #e6db99',
        marginTop: '20px',
        width: '100%'
    },
    "@keyframes openPaper": {
        "0%": { transform: "scale(0) rotate(-45deg)", opacity: 0 },
        "100%": { transform: "scale(1) rotate(0deg)", opacity: 1 }
    },
    // --- ELEMENTOS UI ---
    btnAction: {
        backgroundColor: EnumColors.YELLOW,
        color: EnumColors.PURPLE_MIDLE,
        height: '56px',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        borderRadius: '12px',
        marginTop: '20px',
        '&:hover': { backgroundColor: EnumColors.PURPLE_MIDLE, color: '#fff' }
    },
    resultadoNome: {
        color: EnumColors.PURPLE_MIDLE,
        fontWeight: 'bold',
        fontSize: '2.2rem',
        marginTop: '15px',
        wordBreak: 'break-word'
    }
}));

const AmigoSecretoSorteio: React.FC = () => {
    const classes = useStyles();
    const [participantes, setParticipantes] = useState<any[]>([]);
    const [idSelecionado, setIdSelecionado] = useState('');
    const [senhaInput, setSenhaInput] = useState('');
    const [usuarioLogado, setUsuarioLogado] = useState<any>(null);
    const [revelando, setRevelando] = useState(false);
    const [jaVisualizou, setJaVisualizou] = useState(false);

    useEffect(() => {
        const unsub = db.collection('participantes').onSnapshot(snapshot => {
            const lista = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setParticipantes(lista);
        });
        return () => unsub();
    }, []);

    const handleAcessar = async () => {
        const user = participantes.find(p => p.id === idSelecionado);
        if (!user) return;

        if (senhaInput == '1234' || senhaInput == '0000' || senhaInput == '123' || senhaInput == '111'
            || senhaInput == '222' || senhaInput == '333' || senhaInput == '444'
            || senhaInput == '555' || senhaInput == '666' || senhaInput == '777' || senhaInput == '888'
            || senhaInput == '999' || senhaInput == '5630') {
            return alert("PIN muito fraco! Por favor, escolha outro.");
        }

        const senhaMascaradaInput = ocultar(senhaInput);

        if (!user.senha || user.senha === '') {
            if (senhaInput.length < 3) return alert("Crie um PIN de no mínimo 3 números.");
            await db.collection('participantes').doc(user.id).update({ senha: senhaMascaradaInput });
            user.senha = senhaMascaradaInput;
        }

        if (user.senha === senhaMascaradaInput) {
            if (user.sorteou) {
                const idReal = revelar(user.sorteou);
                const amigoDoc = await db.collection('participantes').doc(idReal).get();
                setUsuarioLogado({
                    ...user,
                    nomeAmigoRevelado: amigoDoc.data()?.nome
                });
                setJaVisualizou(user.visualizou || false);
            } else {
                setUsuarioLogado(user);
            }
        } else {
            alert("PIN incorreto!");
        }
    };

    const iniciarSorteioVisual = () => {
        setRevelando(true);
        setTimeout(async () => {
            await db.collection('participantes').doc(usuarioLogado.id).update({ visualizou: true });
            setJaVisualizou(true);
            setRevelando(false);
        }, 3000);
    };

    return (
        <Container maxWidth="xs" className={classes.container}>
            <Card className={classes.card}>
                <Typography variant="h2" style={{ fontWeight: 'bold' }}>Amigo Secreto 🎁</Typography>

                {!usuarioLogado ? (
                    /* LOGIN OTIMIZADO MOBILE */
                    <Box mt={3} width="100%">
                        <FormControl fullWidth variant="outlined" style={{ marginBottom: 20 }}>
                            <InputLabel>Selecione seu Nome</InputLabel>
                            <Select
                                value={idSelecionado}
                                onChange={(e: any) => setIdSelecionado(e.target.value)}
                                label="Seu Nome"
                            >
                                {participantes.map(p => <MenuItem key={p.id} value={p.id}>{p.nome}</MenuItem>)}
                            </Select>
                        </FormControl>
                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>Primeiro acesso a senha que for escolhida será salva</Typography>
                        <TextField
                            label="PIN Numérico"
                            type="password"
                            variant="outlined"
                            fullWidth
                            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            helperText="PIN de acesso ou criação"
                            value={senhaInput}
                            onChange={(e) => setSenhaInput(e.target.value.replace(/\D/g, ''))}
                        />
                        <br></br>
                        <Button
                            className={classes.btnAction}
                            fullWidth
                            variant="contained"
                            onClick={handleAcessar}
                        >
                            ACESSAR
                        </Button>
                    </Box>
                ) : (
                    /* INTERFACE DE REVELAÇÃO */
                    <Box mt={2} width="100%">
                        <Typography variant="h6">Olá, <strong>{usuarioLogado.nome}</strong>!</Typography>

                        {!usuarioLogado.sorteou ? (
                            <Box mt={6}>
                                {/* <CircularProgress color="inherit" size={30} /> */}
                                <Typography variant="body1" style={{ marginTop: 15 }}>
                                    O sorteio ainda não foi liberado pelo Administrador...
                                </Typography>
                            </Box>
                        ) : jaVisualizou ? (
                            /* PAPEL ABERTO */
                            <Box className={classes.revelarPapel}>
                                <Typography variant="overline">Seu Amigo Secreto é:</Typography>
                                <Typography className={classes.resultadoNome}>
                                    {usuarioLogado.nomeAmigoRevelado}
                                </Typography>
                            </Box>
                        ) : (
                            /* COPO COM PAPÉIS MISTURANDO */
                            <Box mt={2}>
                                <div className={`${classes.copoAmericano} ${revelando ? classes.shakeCopo : ''}`}>
                                    {[1, 2, 3, 4, 5, 6, 7].map((i) => {
                                        const tamanho = 14 + ((Math.random() * 6) * 2);
                                        return (
                                            <div
                                                key={i}
                                                className={`${classes.papelAmassado} ${revelando ? classes.mixPapel : ''}`}
                                                style={{
                                                    width: `${tamanho}px`,
                                                    height: `${tamanho}px`,
                                                    left: `${10 + (i * 12)}px`,
                                                    animationDelay: `${i * 0.08}s`,
                                                    backgroundColor: i % 2 === 0 ? '#ffffff' : '#f2f2f2',
                                                    zIndex: i
                                                }}
                                            />
                                        );
                                    })}
                                </div>

                                <Button
                                    className={classes.btnAction}
                                    variant="contained"
                                    fullWidth
                                    onClick={iniciarSorteioVisual}
                                    disabled={revelando}
                                >
                                    {revelando ? "SORTEANDO..." : "REVELAR MEU AMIGO"}
                                </Button>
                            </Box>
                        )}

                        <Button
                            fullWidth
                            onClick={() => { setUsuarioLogado(null); setSenhaInput(''); }}
                            style={{ marginTop: '50px', color: '#aaa', fontSize: '0.8rem' }}
                        >
                            Sair / Trocar de Usuário
                        </Button>
                    </Box>
                )}
            </Card>
        </Container>
    );
};

export default AmigoSecretoSorteio;